import React from 'react';
import { processSteps, processContent } from '../data';
import { ProcessProps } from '../types';
import ProcessPresentation from './ProcessPresentation';

const ProcessContainer: React.FC<ProcessProps> = ({ 
  className, 
  id = 'process' 
}) => {
  return (
    <ProcessPresentation
      id={id}
      heading={processContent.heading}
      description={processContent.description}
      steps={processSteps}
    />
  );
};

export default ProcessContainer;